import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from './__root';
import { requireAuth } from '@/lib/route-guards';

/**
 * Microsoft admin-consent callback target. The backend redirects the browser to
 * `${FRONTEND_URL}/connect-mailbox?tenant=<id>&state=<s>` on success, or
 * `?error=...` on cancel. Forgiving parse (`.catch`) so a malformed redirect
 * still renders the callback content rather than 404-ing.
 */
const connectMailboxSearchSchema = z.object({
  tenant: z.string().optional().catch(undefined),
  state: z.string().optional().catch(undefined),
  error: z.string().optional().catch(undefined),
});

export const connectMailboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/connect-mailbox',
  beforeLoad: requireAuth,
  validateSearch: connectMailboxSearchSchema,
  component: lazyRouteComponent(
    () => import('@/features/dwd-workspace/ConnectMailboxCallback'),
    'ConnectMailboxCallback',
  ),
});
